import { render, staticRenderFns } from "./Dispatcher.vue?vue&type=template&id=16219487&scoped=true&"
import script from "./Dispatcher.vue?vue&type=script&lang=js&"
export * from "./Dispatcher.vue?vue&type=script&lang=js&"
import style0 from "./Dispatcher.vue?vue&type=style&index=0&id=16219487&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16219487",
  null
  
)

export default component.exports